// extracted by mini-css-extract-plugin
export default {"container":"PendingList_container__BiCFe","cardContainer":"PendingList_cardContainer__gxK+9","noContents":"PendingList_noContents__juhVn"};